import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SearchNavigationBar from "./SearchNavigationBar/SearchNavigationBar";
import StatusNavigationBar from "./StatusNavigationBar";
import { RegionDataResource } from "../../../../resources/js/search/proptypes/region-data-resource";

const MainNavigationBar = props => {
    const {
        browseAllUrl,
        searchCategoryUrl,
        regionData,
    } = props;

    const [showSearchBar, setShowSearchbar] = useState(false);

    const toggleSearchBar = (forceState) => {
        if (forceState !== undefined) {
            setShowSearchbar(forceState);
            return;
        }
        setShowSearchbar(prevState => !prevState);
    }

    if (showSearchBar) {
        return (
            <div className="w-100">
                <SearchNavigationBar
                    onSearchHide={() => toggleSearchBar(false)}
                />
            </div>
        )
    }

    return (
        <StatusNavigationBar
            browseAllUrl={browseAllUrl}
            searchCategoryUrl={searchCategoryUrl}
            toggleSearchBar={toggleSearchBar}
            regionData={regionData}
        />
    );
};

MainNavigationBar.propTypes = {
    browseAllUrl: PropTypes.string.isRequired,
    searchCategoryUrl: PropTypes.string.isRequired,
    regionData: PropTypes.shape(RegionDataResource),
};

export default MainNavigationBar;
